<template>
    <div class="page-container">
        <div class="content">
            <div class="selector-header">
                <img v-if="logo" :src="logo" alt="logo" class="logo" />
                <h1>Seleccionar Terminal Bold</h1>
                <p>Seleccione el terminal que desea utilizar para los pagos</p>
            </div>

            <div style="margin-bottom: 10px;">
                <span style="margin-right: 10px;">Punto:</span>
                <select id="pointsList" class="select-icono" required v-model="point_id">
                    <option value="0" disabled selected>Seleccione el punto</option>
                    <option v-for="p in points" :key="p.id_point" :value="p.id_point">
                        {{ p.name }}
                    </option>
                </select>
                <input v-model="bold_status" type="checkbox" style="margin-left: 10px;">Estado</input>
            </div>

            <div v-if="!point_id" class="loading-container">
                <p>Seleccione un punto.</p>
            </div>

            <div v-if="loading" class="loading-container">
                <p>Consultando terminales disponibles...</p>
            </div>

            <div v-else-if="terminals.length > 0" class="terminals-grid">
                <div
                    v-for="terminal in terminals"
                    :key="terminal.terminal_serial"
                    class="terminal-card"
                    :class="{
                        selected:
                            selectedTerminal &&
                            selectedTerminal.terminal_serial ===
                                terminal.terminal_serial,
                    }"
                    @click="selectTerminal(terminal)"
                >
                    <div class="terminal-icon">
                        <i class="fa fa-desktop terminal-icon-svg"></i>
                    </div>
                    <div class="terminal-info">
                        <h3>
                            {{ terminal.name }} - {{ terminal.terminal_model }}
                        </h3>
                        <p class="serial">{{ terminal.terminal_serial }}</p>
                        <div
                            class="status-indicator"
                            :class="getStatusClass(terminal.status)"
                        >
                            <i class="feather icon-circle"></i>
                            <span>{{ getStatusText(terminal.status) }}</span>
                        </div>
                    </div>
                    <div
                        class="selection-indicator"
                        v-if="
                            selectedTerminal &&
                            selectedTerminal.terminal_serial ===
                                terminal.terminal_serial
                        "
                    >
                        <i class="feather icon-check-circle"></i>
                    </div>
                </div>
            </div>

            <div v-else class="no-terminals" style="display: flex; flex-direction: column; align-items: center;">
                <div class="no-terminals-icon">
                    <i class="fa fa-desktop"></i>
                </div>
                <h2>No hay terminales disponibles</h2>
                <p>
                    No se encontraron terminales Bold configurados para este
                    punto de venta.
                </p>
                <vs-button color="primary" @click="refreshTerminals">
                    <i class="feather icon-refresh-cw mr-2"></i>
                    Consultar
                </vs-button>
            </div>

            <div class="actions" v-if="terminals.length > 0">
                <vs-button
                    color="primary"
                    @click="saveSelection"
                    :disabled="!selectedTerminal || loading"
                    size="large"
                >
                    <i class="feather icon-save mr-2"></i>
                    Guardar Selección
                </vs-button>
                <vs-button
                    color="warning"
                    type="border"
                    @click="refreshTerminals"
                    :disabled="loading"
                >
                    <i class="feather icon-refresh-cw mr-2"></i>
                    Actualizar Lista
                </vs-button>
            </div>

            <div class="current-selection" v-if="currentSavedTerminal">
                <vs-alert color="success">
                    <i class="feather icon-info mr-2"></i>
                    Terminal actual:
                    <strong
                        >{{ currentSavedTerminal.terminal_model }} -
                        {{ currentSavedTerminal.terminal_serial }}</strong
                    >
                </vs-alert>
            </div>
        </div>

        <footer class="footer">
            <span>
                Tecnología
                <a
                    href="https://info.vinapp.co"
                    target="_blank"
                    rel="noopener noreferrer"
                    >VinApp</a
                >
            </span>
        </footer>
    </div>
</template>

<script>
import axios from '@/config/axios';
import BoldTerminalHelper from "../helpers/BoldTerminalHelper";

export default {
    name: "BoldTerminalSelector",
    data() {
        return {
            terminals: [],
            selectedTerminal: null,
            currentSavedTerminal: null,
            loading: false,
            bold_status: localStorage.getItem("bold_status") ? localStorage.getItem("bold_status") === 'true' ? true : false : false,
            logo: localStorage.getItem("logo_company"),
            point_id: localStorage.getItem("bold_point_id"),
            points: JSON.parse(localStorage.getItem('puntos')),
        };
    },
    methods: {
        async loadTerminals() {
            this.loading = true;
            try {
                const response = await axios.get(
                    `/api/config-bold/terminals/${this.point_id}`
                );

                if (response.data.success) {
                    this.terminals =
                        response.data.data.payload.available_terminals || [];
                    if(this.terminals){
                        this.terminals.forEach(element => {
                            element.user_email=response.data.data.payload.user_email
                        });
                    }
                    this.currentSavedTerminal =
                        BoldTerminalHelper.getSelectedTerminal();
                    if (this.currentSavedTerminal) {
                        // Buscar el terminal guardado en la lista actual
                        const found = this.terminals.find(
                            (t) =>
                                t.terminal_serial ===
                                this.currentSavedTerminal.terminal_serial
                        );
                        if (found) {
                            this.selectedTerminal = found;
                        }
                    }
                } else {
                    this.terminals = [];
                    console.error('Error al cargar terminales')
                }
            } catch (error) {
                console.error("Error loading terminals:", error);
                this.terminals = [];
            }
            this.loading = false;
        },
        selectTerminal(terminal) {
            if (
                terminal.status !== "available" &&
                terminal.status !== "BINDED"
            ) {
                console.log('Este terminal no está disponible en este momento')
                return;
            }
            this.selectedTerminal = terminal;
        },
        saveSelection() {
            if (!this.selectedTerminal) {
                console.log('Por favor seleccione un terminal')
                return;
            }

            // Guardar usando el helper
            const success = BoldTerminalHelper.setSelectedTerminal(
                this.selectedTerminal
            );

            if (success) {
                this.currentSavedTerminal = { ...this.selectedTerminal };
                console.log('Terminal ${this.selectedTerminal.terminal_model} - ${this.selectedTerminal.terminal_serial} guardado como predeterminado.')

                // Opcional: regresar a la vista anterior después de guardar
                setTimeout(() => {
                    this.$router.go(-1);
                }, 1500);
            } else {
                console.error('No se pudo guardar la selección del terminal.')
            }
        },
        refreshTerminals() {
            this.loadTerminals();
        },
        getStatusText(status) {
            const statuses = {
                available: "Disponible",
                busy: "Ocupado",
                offline: "Desconectado",
                error: "Error",
            };
            return statuses[status] || status;
        },
        getStatusClass(status) {
            const classes = {
                available: "status-available",
                busy: "status-busy",
                offline: "status-offline",
                error: "status-error",
            };
            return classes[status] || "";
        },
    },
    mounted() {
        if(this.point_id)this.loadTerminals();
    },
    watch: {
        point_id(newValue) {
            localStorage.setItem("bold_point_id", newValue);
            this.loadTerminals();
        },
        bold_status(newValue) {
            localStorage.setItem("bold_status", newValue);
        }  
    }
};
</script>

<style scoped>
.page-container {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.content {
    flex: 1;
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
}

.selector-header {
    text-align: center;
    margin-bottom: 3rem;
}

.logo {
    max-height: 80px;
    margin-bottom: 1rem;
}

.selector-header h1 {
    font-size: 2rem;
    color: #333;
    margin-bottom: 0.5rem;
}

.selector-header p {
    color: #666;
    font-size: 1.1rem;
}

.loading-container {
    text-align: center;
    padding: 4rem 2rem;
}

.loading-container p {
    margin-top: 1rem;
    color: #666;
}

.terminals-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 2rem;
    margin-bottom: 3rem;
}

.terminal-card {
    background: #fff;
    border: 2px solid #e9ecef;
    border-radius: 1rem;
    padding: 2rem;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: relative;
}

.terminal-card:hover {
    border-color: #007bff;
    transform: translateY(-5px);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
}

.terminal-card.selected {
    border-color: #28a745;
    background: #f8fff9;
}

.terminal-icon {
    margin-bottom: 1rem;
}

.terminal-icon-svg {
    font-size: 3rem;
    color: #6c757d;
}

.terminal-card.selected .terminal-icon-svg {
    color: #28a745;
}

.terminal-info h3 {
    font-size: 1.5rem;
    color: #333;
    margin-bottom: 0.5rem;
}

.terminal-info .serial {
    font-family: "Courier New", monospace;
    background: #f8f9fa;
    padding: 0.5rem;
    border-radius: 0.25rem;
    color: #495057;
    font-weight: 600;
    margin-bottom: 1rem;
}

.status-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    font-weight: 600;
}

.status-indicator i {
    font-size: 0.8rem;
}

.status-available {
    color: #28a745;
}

.status-busy {
    color: #ffc107;
}

.status-offline {
    color: #6c757d;
}

.status-error {
    color: #dc3545;
}

.selection-indicator {
    position: absolute;
    top: 1rem;
    right: 1rem;
    color: #28a745;
    font-size: 1.5rem;
}

.no-terminals {
    text-align: center;
    padding: 4rem 2rem;
}

.no-terminals-icon {
    font-size: 4rem;
    color: #6c757d;
    margin-bottom: 2rem;
}

.no-terminals h2 {
    color: #333;
    margin-bottom: 1rem;
}

.no-terminals p {
    color: #666;
    margin-bottom: 2rem;
}

.actions {
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 2rem;
    flex-wrap: wrap;
}

.current-selection {
    margin-bottom: 2rem;
}

.footer {
    height: 60px;
    text-align: center;
    font-size: 14px;
    color: #666;
    background: #f8f9fa;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #ddd;
}

.footer a {
    color: #0073e6;
    text-decoration: none;
}

.footer a:hover {
    text-decoration: underline;
}

@media (max-width: 768px) {
    .terminals-grid {
        grid-template-columns: 1fr;
    }

    .actions {
        flex-direction: column;
        align-items: center;
    }

    .actions .vs-button {
        width: 100%;
        max-width: 300px;
    }
}
.select-icono{
    padding: 0.7rem;
    font-size: 1rem;
    border: 1px solid rgba(0, 0, 0, 0.2);
    color: #626262;
    border-radius: 4px;
    appearance: none;
    -webkit-appearance: none;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-size: 28px;
    background-position-x: 100%;
    background-position-y: 7px;
}   
</style>